import _ from 'lodash'
import { round, getPrecisionOrDefault } from 'scoreboard/components/format-value'


/**
 *	Filters the suggestion values for numeric filter selects
 * @param values {string[] | number[]}
 * @param field {{dataType: String, precision: Number}}
 */
function filterNumericValues(values, field) {
	return _(values)
		// convert all applicable values to floats
		.map(value => {
			// if this value isn't a float, no need to round or do anything with precision
			if (!isFloat(value)) return value

			return roundToPrecision(value, field)
		})
		.uniq()	// remove duplicates
		.value()
}

/**
 * Rounds the field to the correct precision
 * @param value {Any}
 * @param field {{dataType: String, precision: Number}}
 */
function roundToPrecision(value, field) {
	const precision = getPrecisionOrDefault(field.precision, field.dataType)
	if (field.dataType === 'percent') {
		// percent suggestions come from the backend with the decimal moved
		// over 2 places, so move it back before rounding, so the precision is correct
		// i.e. 80.293920 becomes 8029.3920
		value = value * 100
	}

	const roundedValue = round(value, precision)
	if (field.dataType === 'percent') {
		// undo the previous moving of the decimal, so this is a percentage again
		// i.e. 8029.3920 becomes 80.2939 (rounded)
		return roundedValue / 100
	}

	return roundedValue
}

/**
 * Gets the options for format-value.js for numeric values in filters
 * @param value {Any}
 * @param field {{dataType: String, precision: Number, currencyCode: String}}
 */
function getNumericFormatValueOptions(value, field) {
	return {
		dataType: field.dataType,
		value,
		shorten: false,
		precision: field.precision,
		currencyCode: field.currencyCode
	}
}

/**
 * Gets all the values in the suggestions that match the value given, taking into account
 * the field's precision.
 * @param value {string}
 * @param suggestions {Any[]}
 * @param field {{dataType: String, precision: Number}}
 * @returns {Number[]}
 */
function getAllValuesFromSuggestionsForFilterValue(value, suggestions, field) {
	// #45018 don't need to pull in any suggestions if this value isn't a float
	if (!isFloat(value)) return []

	const valueAsFloat = parseFloat(value)
	return _.filter(suggestions, suggestion =>
		roundToPrecision(suggestion, field) === valueAsFloat)
}

function isFloat(number) {
	return !_.isNaN(parseFloat(number)) && parseFloat(number) % 1 !== 0
}

export { filterNumericValues }
export { roundToPrecision }
export { getNumericFormatValueOptions }
export { getAllValuesFromSuggestionsForFilterValue }